(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8601],{

/***/ 55972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _defs, _circle, _use, _use2, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgBasicIconSvg(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "basic_icon_svg_svg__a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feColorMatrix", {
    values: "0 0 0 0 0.239215686 0 0 0 0 0.254901961 0 0 0 0 0.356862745 0 0 0 1 0",
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feMerge", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "basic_icon_svg_svg__d"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.9026726 0 0 0 0 0.83054497 0 0 0 0.775213068 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", {
    x: "-22.9%",
    y: "-28.2%",
    width: "145.9%",
    height: "156.5%",
    filterUnits: "objectBoundingBox",
    id: "basic_icon_svg_svg__e"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feColorMatrix", {
    values: "0 0 0 0 0.760784314 0 0 0 0 0.807843137 0 0 0 0 0.850980392 0 0 0 0.305233829 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", {
    x: "-22.9%",
    y: "-28.2%",
    width: "145.9%",
    height: "156.5%",
    filterUnits: "objectBoundingBox",
    id: "basic_icon_svg_svg__g"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feOffset", {
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feColorMatrix", {
    values: "0 0 0 0 0.242461252 0 0 0 0 0.298645712 0 0 0 0 0.334578804 0 0 0 0.5 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10.5 0a2.094 2.094 0 011.031 3.92 8.808 8.808 0 005.39 2.602 2.098 2.098 0 011.98-2.797c1.159 0 2.099.937 2.099 2.094 0 1.157-.94 2.095-2.1 2.095h-.04l-2.593 8.35a1.047 1.047 0 01-1 .736H5.782c-.472 0-.886-.316-1.01-.772l-2.28-8.35A2.098 2.098 0 010 5.82c0-1.158.94-2.096 2.1-2.096a2.098 2.098 0 011.967 2.83 8.081 8.081 0 005.441-2.612A2.094 2.094 0 0110.5 0z",
    id: "basic_icon_svg_svg__c"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.99 8.597l-3.357 5.153a.2.2 0 01-.149.08h-.788a.152.152 0 01-.13-.088L7.47 8.605c-.02-.048.007-.089.06-.089H9.93c.052 0 .076.039.05.084l-.341.502a.228.228 0 00-.011.173l.709 1.839c.019.048.058.053.086.008l1.64-2.525a.199.199 0 01.148-.08h1.734c.053-.001.073.035.045.08z",
    id: "basic_icon_svg_svg__f"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
    x1: "32.53%",
    y1: "28.861%",
    x2: "71.636%",
    y2: "82.766%",
    id: "basic_icon_svg_svg__b"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    stopColor: "#E9F1F7",
    offset: "0%"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    stopColor: "#C2D5E2",
    offset: "100%"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    fill: "#688097",
    cx: 16,
    cy: 16,
    r: 16
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    filter: "url(#basic_icon_svg_svg__a)",
    transform: "translate(5.5 7.5)"
  }, _use || (_use = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "url(#basic_icon_svg_svg__b)",
    xlinkHref: "#basic_icon_svg_svg__c"
  })), _use2 || (_use2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "#000",
    filter: "url(#basic_icon_svg_svg__d)",
    xlinkHref: "#basic_icon_svg_svg__c"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10.5 0a2.094 2.094 0 011.031 3.92 8.808 8.808 0 005.39 2.602 2.098 2.098 0 011.98-2.797c1.159 0 2.099.937 2.099 2.094 0 1.157-.94 2.095-2.1 2.095h-.04l-2.593 8.35a1.047 1.047 0 01-1 .736l-4.767-.001V0z",
    fillOpacity: 0.5,
    fill: "#C4CFDB",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "#000",
    filter: "url(#basic_icon_svg_svg__e)",
    xlinkHref: "#basic_icon_svg_svg__f"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "#8BAAC7",
    xlinkHref: "#basic_icon_svg_svg__f"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "#000",
    filter: "url(#basic_icon_svg_svg__g)",
    xlinkHref: "#basic_icon_svg_svg__f"
  }))))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgBasicIconSvg);

/***/ }),

/***/ 66260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _defs, _circle, _use, _use2, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgEnterpriseIconSvg(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "enterprise_icon_svg_svg__a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0588235294 0 0 0 0 0.062745098 0 0 0 0 0.223529412 0 0 0 1 0",
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feMerge", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "enterprise_icon_svg_svg__d"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.933195613 0 0 0 0 0.83054497 0 0 0 0.775213068 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", {
    x: "-22.9%",
    y: "-28.2%",
    width: "145.9%",
    height: "156.5%",
    filterUnits: "objectBoundingBox",
    id: "enterprise_icon_svg_svg__e"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.963454141 0 0 0 0 0.880525915 0 0 0 0.5 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", {
    x: "-22.9%",
    y: "-28.2%",
    width: "145.9%",
    height: "156.5%",
    filterUnits: "objectBoundingBox",
    id: "enterprise_icon_svg_svg__g"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feOffset", {
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feColorMatrix", {
    values: "0 0 0 0 0.726336051 0 0 0 0 0.362890041 0 0 0 0 0.0834566766 0 0 0 0.5 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10.5 0a2.094 2.094 0 011.031 3.92 8.808 8.808 0 005.39 2.602 2.098 2.098 0 011.98-2.797c1.159 0 2.099.937 2.099 2.094 0 1.157-.94 2.095-2.1 2.095h-.038l-2.595 8.35a1.047 1.047 0 01-1 .736H5.782c-.472 0-.886-.316-1.01-.772l-2.28-8.35A2.098 2.098 0 010 5.82c0-1.158.94-2.096 2.1-2.096a2.098 2.098 0 011.967 2.83 8.081 8.081 0 005.441-2.612A2.094 2.094 0 0110.5 0z",
    id: "enterprise_icon_svg_svg__c"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.99 8.597l-3.357 5.153a.2.2 0 01-.149.08h-.788a.152.152 0 01-.13-.088L7.47 8.605c-.02-.048.007-.089.06-.089H9.93c.052 0 .076.039.05.084l-.341.502a.228.228 0 00-.011.173l.709 1.839c.019.048.058.053.086.008l1.64-2.525a.199.199 0 01.148-.08h1.734c.053-.001.073.035.045.08z",
    id: "enterprise_icon_svg_svg__f"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
    x1: "32.53%",
    y1: "28.861%",
    x2: "71.636%",
    y2: "82.766%",
    id: "enterprise_icon_svg_svg__b"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    stopColor: "#FFE288",
    offset: "0%"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    stopColor: "#FFBB23",
    offset: "100%"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    fill: "#242552",
    cx: 16,
    cy: 16,
    r: 16
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    filter: "url(#enterprise_icon_svg_svg__a)",
    transform: "translate(5.5 7.5)"
  }, _use || (_use = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "url(#enterprise_icon_svg_svg__b)",
    xlinkHref: "#enterprise_icon_svg_svg__c"
  })), _use2 || (_use2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "#000",
    filter: "url(#enterprise_icon_svg_svg__d)",
    xlinkHref: "#enterprise_icon_svg_svg__c"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10.5 0a2.094 2.094 0 011.031 3.92 8.808 8.808 0 005.39 2.602 2.098 2.098 0 011.98-2.797c1.159 0 2.099.937 2.099 2.094 0 1.157-.94 2.095-2.1 2.095h-.038l-2.595 8.35a1.047 1.047 0 01-1 .736l-4.767-.001V0z",
    fillOpacity: 0.14,
    fill: "#6E3C15",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "#000",
    filter: "url(#enterprise_icon_svg_svg__e)",
    xlinkHref: "#enterprise_icon_svg_svg__f"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "#C4710B",
    xlinkHref: "#enterprise_icon_svg_svg__f"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "#000",
    filter: "url(#enterprise_icon_svg_svg__g)",
    xlinkHref: "#enterprise_icon_svg_svg__f"
  }))))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgEnterpriseIconSvg);

/***/ }),

/***/ 47998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _defs, _circle, _use, _use2, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgProIconSvg(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "pro_icon_svg_svg__a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feColorMatrix", {
    values: "0 0 0 0 0.263643569 0 0 0 0 0.15993062 0 0 0 0 0.113590791 0 0 0 1 0",
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feMerge", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "pro_icon_svg_svg__d"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.9026726 0 0 0 0 0.83054497 0 0 0 0.775213068 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", {
    x: "-22.9%",
    y: "-28.2%",
    width: "145.9%",
    height: "156.5%",
    filterUnits: "objectBoundingBox",
    id: "pro_icon_svg_svg__e"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.924819574 0 0 0 0 0.880525915 0 0 0 0.5 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("filter", {
    x: "-22.9%",
    y: "-28.2%",
    width: "145.9%",
    height: "156.5%",
    filterUnits: "objectBoundingBox",
    id: "pro_icon_svg_svg__g"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feOffset", {
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("feColorMatrix", {
    values: "0 0 0 0 0.178696784 0 0 0 0 0.0655065666 0 0 0 0 0.0295796297 0 0 0 0.5 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10.5 0a2.094 2.094 0 011.031 3.92 8.808 8.808 0 005.39 2.602 2.098 2.098 0 011.98-2.797c1.159 0 2.099.937 2.099 2.094 0 1.157-.94 2.095-2.1 2.095h-.038l-2.595 8.35a1.047 1.047 0 01-1 .736H5.782c-.472 0-.886-.316-1.01-.772l-2.28-8.35A2.098 2.098 0 010 5.82c0-1.158.94-2.096 2.1-2.096a2.098 2.098 0 011.967 2.83 8.081 8.081 0 005.441-2.612A2.094 2.094 0 0110.5 0z",
    id: "pro_icon_svg_svg__c"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.99 8.597l-3.357 5.153a.2.2 0 01-.149.08h-.788a.152.152 0 01-.13-.088L7.47 8.605c-.02-.048.007-.089.06-.089H9.93c.052 0 .076.039.05.084l-.341.502a.228.228 0 00-.011.173l.709 1.839c.019.048.058.053.086.008l1.64-2.525a.199.199 0 01.148-.08h1.734c.053-.001.073.035.045.08z",
    id: "pro_icon_svg_svg__f"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
    x1: "32.53%",
    y1: "28.861%",
    x2: "71.636%",
    y2: "82.766%",
    id: "pro_icon_svg_svg__b"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    stopColor: "#FEDDB5",
    offset: "0%"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    stopColor: "#D19357",
    offset: "100%"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    fill: "#81523D",
    cx: 16,
    cy: 16,
    r: 16
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    filter: "url(#pro_icon_svg_svg__a)",
    transform: "translate(5.5 7.5)"
  }, _use || (_use = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "url(#pro_icon_svg_svg__b)",
    xlinkHref: "#pro_icon_svg_svg__c"
  })), _use2 || (_use2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "#000",
    filter: "url(#pro_icon_svg_svg__d)",
    xlinkHref: "#pro_icon_svg_svg__c"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10.5 0a2.094 2.094 0 011.031 3.92 8.808 8.808 0 005.39 2.602 2.098 2.098 0 011.98-2.797c1.159 0 2.099.937 2.099 2.094 0 1.157-.94 2.095-2.1 2.095h-.038l-2.595 8.35a1.047 1.047 0 01-1 .736l-4.767-.001V0z",
    fillOpacity: 0.14,
    fill: "#693B23",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "#000",
    filter: "url(#pro_icon_svg_svg__e)",
    xlinkHref: "#pro_icon_svg_svg__f"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "#885741",
    xlinkHref: "#pro_icon_svg_svg__f"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    fill: "#000",
    filter: "url(#pro_icon_svg_svg__g)",
    xlinkHref: "#pro_icon_svg_svg__f"
  }))))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgProIconSvg);

/***/ }),

/***/ 16706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Footer; },
  "T": function() { return /* binding */ useFooterLinks; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Grid/index.js + 4 modules
var Grid = __webpack_require__(79458);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Layout/index.js + 3 modules
var Layout = __webpack_require__(64606);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Space/index.js
var Space = __webpack_require__(77303);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/assets/logo_light.png
var logo_light = __webpack_require__(27935);
// EXTERNAL MODULE: ./src/assets/gzh.jpeg
var gzh = __webpack_require__(94933);
// EXTERNAL MODULE: ./src/assets/Mailbox.png
var Mailbox = __webpack_require__(19638);
// EXTERNAL MODULE: ./src/assets/FaceBook.png
var FaceBook = __webpack_require__(5187);
// EXTERNAL MODULE: ./src/assets/Twitter.png
var Twitter = __webpack_require__(60050);
// EXTERNAL MODULE: ./src/assets/ic_whatsapp.png
var ic_whatsapp = __webpack_require__(41377);
// EXTERNAL MODULE: ./src/utils/useLocale.ts
var useLocale = __webpack_require__(83126);
// EXTERNAL MODULE: ./src/utils/useLang.ts
var useLang = __webpack_require__(877);
// EXTERNAL MODULE: ./src/components/Footer/style/index.module.less
var index_module = __webpack_require__(63424);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/language.ts
var language = __webpack_require__(39080);
// EXTERNAL MODULE: ./src/hooks/useToken.ts
var useToken = __webpack_require__(27890);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(42586);
;// CONCATENATED MODULE: ./src/hooks/useGetVersionKey.ts


/** 获取版本更新信息，lang区分语言 */

const useGetVersionKey = () => {
  const lang = (0,useLang/* default */.Z)();
  const VERSION_STORAGE_KEY = `${constants/* VERSION_STORAGE_KEY_PREFIX */.rZ}_${lang}`;
  const VERSION_STORAGE_VALID_KEY = `${constants/* VERSION_STORAGE_VALID_KEY_PREFIX */.LX}_${lang}`;
  return {
    VERSION_STORAGE_KEY,
    VERSION_STORAGE_VALID_KEY
  };
};

/* harmony default export */ var hooks_useGetVersionKey = (useGetVersionKey);
// EXTERNAL MODULE: ./src/api/common.ts
var common = __webpack_require__(74169);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/utils/useLocalStorageWithExpiry.ts
var useLocalStorageWithExpiry = __webpack_require__(57153);
// EXTERNAL MODULE: ./src/store/index.ts
var store = __webpack_require__(26638);
;// CONCATENATED MODULE: ./src/hooks/useGetVersionData.tsx






 // 全局初始化标志，防止多次初始化

let isInitialized = false; // 获取更新日志和版本信息

const useGetVersionData = () => {
  const dispatch = (0,es/* useDispatch */.I0)();
  const {
    versionData,
    versionModalVisible,
    versionDataLoading
  } = (0,es/* useSelector */.v9)(state => state.global);
  const {
    VERSION_STORAGE_KEY
  } = hooks_useGetVersionKey();
  const {
    getItemWithExpiry,
    setItemWithExpiry
  } = (0,useLocalStorageWithExpiry/* default */.Z)({
    key: VERSION_STORAGE_KEY,
    expiryInMinutes: 60 * 12
  }); // 初始化版本数据（只执行一次）

  (0,react.useEffect)(() => {
    if (isInitialized || versionDataLoading) {
      return;
    }

    const initVersionData = async () => {
      try {
        isInitialized = true;
        dispatch((0,store/* updateVersionDataLoading */.JD)(true)); // 从本地存储中获取版本信息

        const versionStorage = getItemWithExpiry();

        if (versionStorage) {
          // 如果本地存储中有版本信息，则将其设置为更新日志
          dispatch((0,store/* updateVersionData */.Gp)(versionStorage));
          dispatch((0,store/* updateVersionDataLoading */.JD)(false));
        } else {
          // 如果本地存储中没有版本信息，则从后端获取
          const res = await (0,common/* getSystemUpdateApi */.yd)();

          if (res.data.code === constants/* SUCCESS_CODE */.Gh) {
            // 获取新版本号
            const newVersion = res.data.data.version; // 更新 Redux store 中的版本号

            dispatch({
              type: 'update-version',
              payload: newVersion
            }); // 将新版本信息存储到本地存储中

            setItemWithExpiry(res.data.data); // 更新版本数据

            dispatch((0,store/* updateVersionData */.Gp)(res.data.data)); // 获取旧版本号

            const oldVersion = localStorage.getItem(constants/* ECHO_VERSION */.o9);
            const shouldShowModal = oldVersion !== JSON.stringify(newVersion);

            if (shouldShowModal) {
              // 将新版本号存储到本地存储中
              localStorage.setItem(constants/* ECHO_VERSION */.o9, JSON.stringify(newVersion)); // 显示弹窗

              dispatch((0,store/* updateVersionModalVisible */.kS)(true));
            }

            dispatch((0,store/* updateVersionDataLoading */.JD)(false));
          }
        }
      } catch (error) {
        console.error('获取版本数据失败:', error);
        dispatch((0,store/* updateVersionDataLoading */.JD)(false));
      }
    };

    initVersionData();
  }, [dispatch, getItemWithExpiry, setItemWithExpiry, versionDataLoading]); // 设置弹窗可见性

  const setVisible = visible => {
    dispatch((0,store/* updateVersionModalVisible */.kS)(visible));
  };

  const versionOnClick = () => setVisible(true);

  return {
    updateLogs: versionData,
    visible: versionModalVisible,
    setVisible,
    versionOnClick
  };
};

/* harmony default export */ var hooks_useGetVersionData = (useGetVersionData);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Modal/index.js + 4 modules
var Modal = __webpack_require__(29735);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Button/index.js + 1 modules
var Button = __webpack_require__(56187);
// EXTERNAL MODULE: ./src/pages/platform/update-log/index.module.less
var update_log_index_module = __webpack_require__(32735);
var update_log_index_module_default = /*#__PURE__*/__webpack_require__.n(update_log_index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/pages/platform/update-log/index.tsx







const UpdateLog = props => {
  const {
    visible,
    setVisible,
    updateLogs
  } = props;
  const t = (0,useLocale/* default */.Z)();
  const logData = (0,react.useMemo)(() => {
    var _updateLogs$descripti, _updateLogs$descripti2;

    return updateLogs === null || updateLogs === void 0 ? void 0 : (_updateLogs$descripti = updateLogs.description) === null || _updateLogs$descripti === void 0 ? void 0 : (_updateLogs$descripti2 = _updateLogs$descripti.map) === null || _updateLogs$descripti2 === void 0 ? void 0 : _updateLogs$descripti2.call(_updateLogs$descripti, (descItem, index) => {
      return {
        key: index + 1,
        data: descItem
      };
    });
  }, [updateLogs]);

  const handleClose = () => {
    setVisible(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal/* default */.Z, {
    className: (update_log_index_module_default()).updateLog,
    title: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: 'https://echosell-static.tos-cn-beijing.volces.com/assets/log.png',
      alt: "",
      className: (update_log_index_module_default())["updateLog-icom"]
    }),
    visible: visible,
    onOk: async () => setVisible(false),
    onCancel: () => setVisible(false),
    autoFocus: false,
    focusLock: true,
    closable: false,
    footer: null,
    style: {
      width: '680px'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      className: (update_log_index_module_default())["updateLog-title"],
      children: [(updateLogs === null || updateLogs === void 0 ? void 0 : updateLogs.title) || t['update.log.title'], /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (update_log_index_module_default()).version,
        onClick: () => {
          (updateLogs === null || updateLogs === void 0 ? void 0 : updateLogs.changelog) && window.open(updateLogs === null || updateLogs === void 0 ? void 0 : updateLogs.changelog);
        },
        children: ["v", updateLogs === null || updateLogs === void 0 ? void 0 : updateLogs.version]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (update_log_index_module_default())["updateLog-matter"],
      children: logData === null || logData === void 0 ? void 0 : logData.map(item => /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (update_log_index_module_default())["updateLog-matter-item"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (update_log_index_module_default())["updateLog-matter-icon"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (update_log_index_module_default())["updateLog-matter-text"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            dangerouslySetInnerHTML: {
              __html: item.data
            }
          })
        })]
      }, item.key))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (update_log_index_module_default())["updateLog-footer"],
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
        size: 'large',
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          type: "outline",
          className: (update_log_index_module_default())["updateLog-footer-discard"],
          onClick: () => {
            (updateLogs === null || updateLogs === void 0 ? void 0 : updateLogs.changelog) && window.open(updateLogs === null || updateLogs === void 0 ? void 0 : updateLogs.changelog);
            handleClose();
          },
          children: t['update.log.discard']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          className: (update_log_index_module_default())["updateLog-footer-now"],
          onClick: handleClose,
          children: t['update.log.update']
        })]
      })
    })]
  });
};

/* harmony default export */ var update_log = (UpdateLog);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/hooks/useLocalePath.ts
var useLocalePath = __webpack_require__(85966);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
;// CONCATENATED MODULE: ./src/components/Footer/index.tsx


const _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
























const Row = Grid/* default.Row */.Z.Row;
const useFooterLinks = () => {
  const t = (0,useLocale/* default */.Z)();
  return [{
    name: t['seo.sitemap.product_breadcrumb'],
    href: '/sitemap/products/best-selling-all-products-in-united-states-on-tiktok/1'
  }, {
    name: t['seo.sitemap.influencer_breadcrumb'],
    href: '/sitemap/influencers/hot-all-influencers-in-united-states-on-tiktok/1'
  }, {
    name: t['seo.sitemap.shop_breadcrumb'],
    href: '/sitemap/shops/best-selling-all-products-in-united-states-on-tiktok/1'
  }, {
    name: t['footer.link.perfcloud'],
    href: 'https://www.perfcloud.cn/'
  }];
};

function Footer() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const t = (0,useLocale/* default */.Z)();
  const {
    isLogin
  } = (0,useToken/* default */.Z)();

  const {
    className
  } = props,
        restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  const lang = (0,useLang/* default */.Z)();
  const {
    updateLogs,
    visible,
    setVisible
  } = hooks_useGetVersionData();
  const isNotChinese = lang !== 'zh-CN';
  const {
    getLocalePath
  } = (0,useLocalePath/* default */.Z)();
  const links = useFooterLinks();
  const products = [{
    name: 'EchoTik',
    desc: t['echotik_desc'],
    href: 'https://echotik.live',
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: logo_light/* default */.Z === null || logo_light/* default */.Z === void 0 ? void 0 : logo_light/* default.src */.Z.src,
      alt: "logo",
      width: 130,
      height: 26
    })
  }, // {
  //   name: '达管家',
  //   desc: 'TikTok达人主动开发平台',
  //   href: 'https://daguanjia.xyz?ref=echotik',
  //   icon: <IconDa />,
  //   hide: lang !== 'zh-CN'
  // },
  {
    name: 'CreatOk',
    desc: t['creatok_desc'],
    href: 'https://creatok.ai',
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: 'https://static.echotik.live/assets/creatok.webp',
      alt: "logo",
      width: 130,
      height: 30
    })
  }, {
    name: '跨境通告',
    desc: 'TikTok专属信息撮合平台',
    href: 'https://www.kjnote.cn/',
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: 'https://static.echotik.live/web/kuajing_logo.jpeg',
      alt: "logo",
      width: 130,
      height: 30
    }),
    hide: lang !== 'zh-CN'
  } // {
  //   name: '领麦分销',
  //   desc: '全球一件代发货盘平台',
  //   href: 'http://www.matelead.com',
  //   icon: <Image src={'https://static.echotik.live/assets/metalead_logo.jpg'} alt="logo" width={130} height={30} />,
  //   hide: lang !== 'zh-CN'
  // }
  ];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* default.Footer */.Z.Footer, _objectSpread(_objectSpread({
    className: classnames_default()((index_module_default()).footer, className)
  }, restProps), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: logo_light/* default */.Z === null || logo_light/* default */.Z === void 0 ? void 0 : logo_light/* default.src */.Z.src,
          alt: "logo",
          width: 170,
          height: 31
        }), isLogin && (updateLogs === null || updateLogs === void 0 ? void 0 : updateLogs.version) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default()).version,
          onClick: () => {
            (updateLogs === null || updateLogs === void 0 ? void 0 : updateLogs.changelog) && window.open(updateLogs === null || updateLogs === void 0 ? void 0 : updateLogs.changelog);
          },
          children: ["v", updateLogs === null || updateLogs === void 0 ? void 0 : updateLogs.version]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default())["footer-content"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default()).aboutUs,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default())["footer-content-headline"],
            children: t['footer.aboutUs']
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).aboutUsText,
            children: t['footer.aboutUs.desc']
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            style: {
              marginTop: 10
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default())["footer-content-headline-wrap"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (index_module_default())["footer-content-headline"],
                children: t['product_list']
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (index_module_default())["footer-content-more"],
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: `/${lang === 'zh-CN' ? 'zh' : 'en'}/products`,
                  target: "_blank",
                  rel: "noreferrer",
                  children: t['message.seeMore']
                })
              })]
            }), products.filter(item => !item.hide).map((product, index) => {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: product.href,
                target: "__blank",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (index_module_default())["footer-product-item"],
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
                    className: (index_module_default())["footer-product-content"],
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (index_module_default())["footer-product-icon"],
                      children: product.icon
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: (index_module_default())["footer-product-text"],
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: (index_module_default())["footer-product-name"],
                        children: product.name
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: (index_module_default())["footer-product-desc"],
                        children: product.desc
                      })]
                    })]
                  })
                })
              }, index);
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default()).guides,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["footer-Guids-content"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default())["footer-content-headline"],
              children: t['footer.guides']
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default()).guidesList,
              children: [{
                title: t['footer.guide.why.echotik'],
                href: getLocalePath(''),
                wrapLink: false
              }, {
                title: t['footer.guide.pricing'],
                href: '/pricing/annually'
              }, {
                title: t['my_report'],
                href: getLocalePath('/reports'),
                wrapLink: false
              }, {
                title: t['footer.guide.e-commerce.analysis'],
                href: getLocalePath('/features/e-commerce'),
                wrapLink: false
              }, {
                title: t['menu.live.monitor'],
                href: getLocalePath('/features/live-monitor'),
                wrapLink: false
              }, {
                title: t['footer.guide.extension'],
                href: getLocalePath('/features/extension'),
                wrapLink: false
              }, {
                title: t['footer.guides.tools'],
                href: '/tool/ai/home'
              }, {
                title: t['footer.guides.changeLog'],
                href: lang === language/* Language.zhCN */.S.zhCN ? 'https://echosell.feishu.cn/wiki/Yj1gwFXfIi2M2xkV1tscLH2Znff' : 'https://help.echotik.live/en/articles/6870452-echotik-upgrade-log',
                wrapLink: false,
                blank: true
              }, {
                title: t['menu.help.center'],
                // href: lang === Language.zhCN ? 'https://help.echotik.live/zh-CN/' : 'https://help.echotik.live/en/',
                href: 'https://help.echotik.live/en/',
                wrapLink: false,
                blank: true
              }, {
                title: t['footer.guide.promotion.alliance'],
                href: getLocalePath('/affiliate-program'),
                wrapLink: false
              }, {
                title: t['footer.guides.blog'],
                href: '/blog',
                wrapLink: false,
                blank: true
              }, {
                title: 'EchoTik社媒',
                href: getLocalePath('/social-media'),
                wrapLink: false,
                hide: lang !== 'zh-CN'
              }, {
                title: '关于我们',
                href: getLocalePath('/aboutus'),
                wrapLink: false,
                hide: lang !== 'zh-CN'
              }].filter(i => !i.hide).map((_ref, index) => {
                let {
                  title,
                  href,
                  wrapLink = true,
                  blank,
                  isCustom
                } = _ref;

                if (isCustom) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: title
                  });
                }

                if (wrapLink) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                    href: href,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      className: (index_module_default()).guidesItem,
                      children: title
                    })
                  }, index);
                }

                return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: href,
                  className: (index_module_default()).guidesItem,
                  target: blank ? '_blank' : '_self',
                  rel: "noreferrer",
                  children: title
                }, index);
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              marginTop: 20
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.producthunt.com/products/echotik",
              target: "_blank",
              rel: "noreferrer",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: "https://static.echotik.live/web/product_review.svg",
                alt: "EchoTik - EchoTik.live is a TikTok data tool.   | Product Hunt",
                width: 250,
                height: 54
              })
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default()).contactUs,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["footer-content-header"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default())["footer-content-headline-left"],
              children: t['footer.contactUs']
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default())["footer-content-more"],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: `/${lang === 'zh-CN' ? 'zh' : 'en'}/social-media`,
                target: "_blank",
                rel: "noreferrer",
                children: t['message.seeMore']
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default()).contactChannelList,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default()).contactChannelItem,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                width: 36,
                height: 36,
                src: Mailbox/* default */.Z,
                alt: "mail"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: (index_module_default()).contactChannelItemName,
                href: "mailto:support@echosell.com",
                target: "_blank",
                rel: "noreferrer",
                children: "Mailbox"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default()).contactChannelItem,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                width: 36,
                height: 36,
                src: FaceBook/* default */.Z,
                alt: "facebook"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: (index_module_default()).contactChannelItemName,
                href: "https://www.facebook.com/echotik",
                target: "_blank",
                rel: "noreferrer",
                children: "Facebook"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default()).contactChannelItem,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                width: 36,
                height: 36,
                src: ic_whatsapp/* default */.Z,
                alt: "whatsapp"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: (index_module_default()).contactChannelItemName,
                href: "https://chat.whatsapp.com/FmfhPcEqKJq40JeCrPlOhx",
                target: "_blank",
                rel: "noreferrer",
                children: "WhatsApp"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default()).contactChannelItem,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                width: 36,
                height: 36,
                src: Twitter/* default */.Z,
                alt: "twitter"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: (index_module_default()).contactChannelItemName,
                href: "https://twitter.com/EchosellM",
                target: "_blank",
                rel: "noreferrer",
                children: "Twitter"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default()).contactChannelItem,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                style: {
                  width: 36,
                  height: 36,
                  borderRadius: '50%',
                  background: '#fff',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaDiscord */.j2d, {
                  style: {
                    width: 20,
                    height: 20,
                    color: '#000'
                  }
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: (index_module_default()).contactChannelItemName,
                href: "https://discord.gg/j5R55frXj4",
                target: "_blank",
                rel: "noreferrer",
                children: "Discord"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default()).contactChannelItem,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                style: {
                  width: 36,
                  height: 36,
                  borderRadius: '50%',
                  background: '#fff',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaLinkedin */.ltd, {
                  style: {
                    width: 20,
                    height: 20,
                    color: '#000'
                  }
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: (index_module_default()).contactChannelItemName,
                href: "https://www.linkedin.com/company/103295803/admin/feed/posts/",
                target: "_blank",
                rel: "noreferrer",
                children: "Linkedin"
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default()).qrCodeList,
            children: [isNotChinese ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default()).qrCodeItem,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                alt: "image",
                width: 104,
                height: 104,
                src: `https://static.echotik.live/qr_code/whatsapp_seller.png?t=${constants/* CACHE_TIMESTAMP */.YG}`
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "WhatsApp"
              })]
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default()).qrCodeItem,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                width: 104,
                height: 104,
                alt: "image",
                src: gzh/* default */.Z
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: t['footer.follow.official.account']
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default()).qrCodeItem,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                width: 104,
                height: 104,
                alt: "image",
                src: (0,constants/* getCustomerServiceQrcodeUrl */._Z)()
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: t['footer.join.group']
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default()).qrCodeItem,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                width: 104,
                height: 104,
                alt: "image",
                src: (0,constants/* getCustomerServiceQrcodeUrl */._Z)()
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: t['footer.contact.echoTik']
              })]
            })]
          }), lang === language/* Language.zhCN */.S.zhCN && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (index_module_default()).moreGroup,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default()).moreGroupTitle,
              children: "TikTok\u4E13\u5C5E\u5206\u7C7B\u4EA4\u6D41\u7FA4"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default()).moreGroupDesc,
              children: "\uFF08\u7F8E\u56FD/\u5370\u5C3C/\u9A6C\u6765/\u8D8A\u5357\u2026)"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default()).moreGroupBtn,
              onClick: () => {
                window.open(`https://help.echotik.live/zh-CN/articles/8119124`);
              },
              children: "\u52A0\u5165\u7FA4\u804A"
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default())["footer-bottom"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (index_module_default())["footer-line"]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default())["footer-text"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: `Copyright ©${new Date().getFullYear()}`
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "http://beian.miit.gov.cn",
            target: "_blank",
            rel: "noreferrer",
            style: {
              marginLeft: '20px'
            },
            children: "\u4EACICP\u59072024093724\u53F7-1"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "http://beian.miit.gov.cn",
            target: "_blank",
            rel: "noreferrer",
            style: {
              marginLeft: '20px'
            },
            children: "\u4EACICP\u59072023013450\u53F7-3"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://echotik.live/privacy-policy.html",
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: classnames_default()((index_module_default())["privacy-policy"], (index_module_default())["footer-text"]),
              children: t['footer.policy']
            })
          }), links.map((link, index) => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: link.href,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                style: {
                  marginLeft: '20px'
                },
                target: "_blank",
                children: link.name
              })
            }, link.href || index);
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(update_log, {
      visible: visible,
      setVisible: setVisible,
      updateLogs: updateLogs
    })]
  }));
}

/* harmony default export */ var components_Footer = (Footer);

/***/ }),

/***/ 48059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useAfterLogin; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_checkLogin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23199);
/* harmony import */ var _utils_useStorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42644);



// 登陆后处理缓存
function useAfterLogin(_ref) {
  let {
    rememberPassword,
    noRedirect = false
  } = _ref;
  const [loginParams, setLoginParams, removeLoginParams] = (0,_utils_useStorage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)('loginParams');
  const {
    query
  } = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();

  function afterLoginSuccess(params, data) {
    var _data$data;

    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params));
    } else {
      removeLoginParams();
    } // 记录登录状态


    if (data !== null && data !== void 0 && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.access_token) {
      var _data$data2;

      (0,_utils_checkLogin__WEBPACK_IMPORTED_MODULE_1__/* .setToken */ .o4)(data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.access_token);
    }

    if (noRedirect) {
      window.location.reload();
    } else {
      window.location.href = '/board';
    }
  }

  function afterPhoneLoginSuccess(params, data) {
    var _data$data3;

    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params));
    } else {
      removeLoginParams();
    } // 记录登录状态


    if (data !== null && data !== void 0 && (_data$data3 = data.data) !== null && _data$data3 !== void 0 && _data$data3.access_token) {
      var _data$data4;

      (0,_utils_checkLogin__WEBPACK_IMPORTED_MODULE_1__/* .setToken */ .o4)(data === null || data === void 0 ? void 0 : (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.access_token);
    }

    if (noRedirect) {
      window.location.reload();
    } else {
      window.location.href = '/board';
    }
  }

  return {
    loginParams,
    afterLoginSuccess,
    afterPhoneLoginSuccess
  };
}

/***/ }),

/***/ 92426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25617);
/* harmony import */ var _hooks_useRegionOptions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3770);



const useCurrencyOptions = () => {
  const {
    region
  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(state => state.ssr);
  const {
    usOption,
    regionOptions
  } = (0,_hooks_useRegionOptions__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  const activeRegion = regionOptions.find(item => item.region === region);
  const currencyOptions = [{
    label: `${usOption === null || usOption === void 0 ? void 0 : usOption.label}(${usOption === null || usOption === void 0 ? void 0 : usOption.sign})`,
    value: (usOption === null || usOption === void 0 ? void 0 : usOption.value) ?? 'USD'
  }];

  if (region !== (usOption === null || usOption === void 0 ? void 0 : usOption.region) && region !== '' && activeRegion !== null && activeRegion !== void 0 && activeRegion.value) {
    currencyOptions.unshift({
      label: `${activeRegion.label}(${activeRegion.sign})`,
      value: activeRegion.value
    });
  }

  return currencyOptions;
};

/* harmony default export */ __webpack_exports__["Z"] = (useCurrencyOptions);

/***/ }),

/***/ 97311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4730);
/* harmony import */ var _api_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74169);
/* harmony import */ var _utils_language__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39080);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42586);
/* harmony import */ var _utils_checkLogin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23199);
/* harmony import */ var _useAfterOnboarding__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30473);
/* harmony import */ var _useAfterLogin__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48059);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59544);
/* harmony import */ var _useToken__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27890);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);


const _excluded = ["client_id", "auto_select", "cancel_on_tap_outside", "context"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 导入相关模块和类型









 // Google One Tap 登录函数

function googleOneTap(_ref, callback) {
  let {
    client_id,
    auto_select = false,
    cancel_on_tap_outside = false,
    context = 'signin'
  } = _ref,
      otherOptions = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_ref, _excluded);

  // 检查 client_id 是否存在
  if (!client_id) {
    throw new Error('client_id is required');
  } // 检查是否在浏览器环境中


  if ( true && window.document) {
    const contextValue = ['signin', 'signup', 'use'].includes(context) ? context : 'signin';
    const googleScript = document.createElement('script');
    googleScript.src = 'https://accounts.google.com/gsi/client';
    googleScript.async = true; // googleScript.defer = true

    document.head.appendChild(googleScript);
    window.addEventListener('load', function () {
      if (window.google) {
        ;
        window.google.accounts.id.initialize(_objectSpread({
          client_id: client_id,
          callback: callback,
          auto_select: auto_select,
          cancel_on_tap_outside: cancel_on_tap_outside,
          context: contextValue
        }, otherOptions));
        window.google.accounts.id.prompt(notification => {
          if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
            console.log('notification getNotDisplayedReason', notification, notification.getNotDisplayedReason());
          }
        });
      }
    });
  }
} // 定义 Token 类型


// 解码 Base64Url
function decodeBase64Url(base64Url) {
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  return JSON.parse(jsonPayload);
} // 解码 JWT 响应


function decodeJwtResponse(t) {
  if (!t) return {};
  const token = {
    raw: '',
    header: {},
    payload: {}
  };
  token.raw = t;
  token.header = JSON.parse(window.atob(t.split('.')[0]));
  token.payload = decodeBase64Url(t.split('.')[1]);
  return token;
} // 使用 Google One Tap 登录的 Hook


const useGoogleOneTap = () => {
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
  const {
    query
  } = router;
  const {
    f = ''
  } = query || {};
  const {
    isLogin
  } = (0,_useToken__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
  const {
    lang
  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_context__WEBPACK_IMPORTED_MODULE_7__/* .GlobalContext */ .kn);
  const {
    afterRegisterSuccess
  } = (0,_useAfterOnboarding__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    rememberPassword: false
  });
  const {
    afterLoginSuccess
  } = (0,_useAfterLogin__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    rememberPassword: false,
    noRedirect: true
  }); // 绑定成功后的操作

  const onBindSuccess = data => {
    var _window, _window$gtag, _data$user;

    (0,_utils_checkLogin__WEBPACK_IMPORTED_MODULE_4__/* .clearInviteCode */ .E$)();
    (0,_utils_checkLogin__WEBPACK_IMPORTED_MODULE_4__/* .setToken */ .o4)(data === null || data === void 0 ? void 0 : data.access_token);
    (_window = window) === null || _window === void 0 ? void 0 : (_window$gtag = _window.gtag) === null || _window$gtag === void 0 ? void 0 : _window$gtag.call(_window, 'event', 'login', {
      entry: 'google'
    });

    if (!(data !== null && data !== void 0 && (_data$user = data.user) !== null && _data$user !== void 0 && _data$user.role)) {
      afterRegisterSuccess();
    } else {
      afterLoginSuccess();
    }
  }; // 绑定 Google 账号


  const bindGoogleAuth = userInfo => {
    const inviteCode = f || localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .INVITE_CODE_STORAGE */ .zX) || '';
    (0,_api_common__WEBPACK_IMPORTED_MODULE_1__/* .bindAuthApi */ .jQ)('google', {
      id: userInfo === null || userInfo === void 0 ? void 0 : userInfo.sub,
      nickname: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
      name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
      email: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email,
      avatar: userInfo === null || userInfo === void 0 ? void 0 : userInfo.picture,
      user: userInfo,
      invite_code: inviteCode
    }).then(bindRes => {
      var _bindRes$data;

      if ((bindRes === null || bindRes === void 0 ? void 0 : (_bindRes$data = bindRes.data) === null || _bindRes$data === void 0 ? void 0 : _bindRes$data.code) === _utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .SUCCESS_CODE */ .Gh) {
        var _bindRes$data2;

        onBindSuccess === null || onBindSuccess === void 0 ? void 0 : onBindSuccess(bindRes === null || bindRes === void 0 ? void 0 : (_bindRes$data2 = bindRes.data) === null || _bindRes$data2 === void 0 ? void 0 : _bindRes$data2.data);
      } else {//
      }
    });
  }; // Google 回调函数


  const onBindGoogleCallback = res => {
    const decodeRes = decodeJwtResponse(res.credential);
    const userInfo = decodeRes === null || decodeRes === void 0 ? void 0 : decodeRes.payload;
    bindGoogleAuth(userInfo);
  }; // 使用 useEffect 进行初始化


  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (lang === _utils_language__WEBPACK_IMPORTED_MODULE_2__/* .Language.zhCN */ .S.zhCN || isLogin) {
      return;
    }

    googleOneTap({
      client_id: _utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .GOOGLE_CLIENT_ID */ .wL
    }, onBindGoogleCallback);
  }, [lang, isLogin]);
};

/* harmony default export */ __webpack_exports__["Z"] = (useGoogleOneTap);

/***/ }),

/***/ 85966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_useLang__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(877);


const useLocalePath = () => {
  const lang = (0,_utils_useLang__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();

  const getLocalePath = path => {
    return `/${lang.slice(0, 2)}${path}`;
  };

  return {
    getLocalePath
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useLocalePath);

/***/ }),

/***/ 5187:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/FaceBook.7afed69a.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAQlBMVEXu7u/k5Obk5OXj4+X19fb19fX5+fn4+Pn////5+fr5+fn4+Pj////+/v7u7u/t7e7n5+jQ0NLIyMvFxcizs7eZmaFgCMOZAAAADHRSTlMAKSkpwMDt7fn6+vqjeduGAAAAPklEQVR42i2LWw6AMAzDQhdGO1Le3P+qqBJ/lmwDjWOlAdYlaZnA9O1yzYjU80pRcJ/KKHXsnvzjbqh9sOEDULcCPCTh/SYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 19638:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Mailbox.8952efe8.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEXv7/Dk5Ob09PX4+Pj29vf19fb19fX4+Pj39/j////d3d/S0tbQ0NS7u8C4uL1eX3BcXG4+P1c4OVMfwBc2AAAACXRSTlMAKcDt+fn5+vpE/kRgAAAAOUlEQVR42j2LSQLAIAjEBqzFoXX9/2PlorkmAUTNVABJDJJAmd0fKoz/6B8NhW2uyhLqdc+hbnz2DTo+AZ/Hs5mwAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 60050:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Twitter.90f73bc2.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAWlBMVEXv7/Du7u/k5Obk5OXj4+X19fb19fX09PX5+fn4+Pn4+Pj////39/fw8PD5+fr5+fn4+Pn4+Pj////+/v78/Pz19fXq6urf39/X19jV1dXNzc2GhoZsbGwAAACxSuRcAAAAEnRSTlMAACkpKcDAwO3t7fn5+fr6+vpbBGHjAAAARElEQVR42iXLWRKAIAwE0TGKcUExg7ty/2tCFf3dDxBdTQWQkaVJ0NPzWqgwvl96aNh4pn9ngNLfxxxdnePQonALrmsyecADYppJZOwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 94933:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/gzh.a52e4c7d.jpeg","height":258,"width":258,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAgACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABgEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAAuwf/xAAdEAABAgcAAAAAAAAAAAAAAAABABECAwQSE1Jh/9oACAEBAAE/ACanOzTDBf3Zf//EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQIBAT8Af//EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQMBAT8Af//Z","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 6363:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/ic_intercom.5e9a71dc.png","height":158,"width":238,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAAAAABd+vKJAAAAMklEQVR42h3GoRUAIAgFQFZ3HKZSsRBBA4mPTy8doVI1C4Sy1uwnmONlSZ8ykrCPuxkuOfMkwNf041cAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 17110:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/ic_mail.cf550de4.png","height":96,"width":96,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAZklEQVR42l2NIQ6EQBAE215yBw/gHGofQgIvA0fCVwh+nwMCBWbHFJsBxYzpFtWlfKGIlVVWRAWvn13cn1PQL4o29fQ0SXyj/iYmNlZGRG61iYWDkxlRmyNdGjLSOvIafTyla0vXXkH3PYsgFZj4AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 41377:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/ic_whatsapp.e4306d89.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAUVBMVEXv7/Du7u/k5Obj4+X19fX09PX09PT4+Pn4+Pj////+/v79/f3n5+f39/j39/f////MzMzIyMjBwcG/v7++vr69vb27u7t6enp4eHhBQUEAAABpWhWrAAAAD3RSTlMAACkpwMDA7e35+fn5+voIXsyEAAAAQUlEQVR42g3GRwKAIAwEwA0xgCWsDdv/H2rmNBA1d1OBFoaqME5Hn2lwbs/X6Wi83nuPZC7nOnJAqgxFgZSbm8oPaBcC4StxyokAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 27935:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo_light.2c160c31.png","height":176,"width":956,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJ0lEQVR4nGMMcXm9Ki6b46RvAM+Lv3//izAxMbxjYGBgBGJBIGYDANTJCXEcS3kHAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":1});

/***/ }),

/***/ 1638:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/whatsapp1012.3775677f.png","height":308,"width":298,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAAAAADhZOFXAAAAU0lEQVR42gFIALf/AMK/2tS21b3JAKqnzLSgqKS4AMe5wZHBtMPPAMiJqMvcvL+6AMJ6udHUu6i6AMu3uJa3wqPJAKmpq7RtoaHGAMPCvs/Dxr7Xh+0uJhHqdI0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 63424:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"width-limit":"index_width-limit__mMU66","overflow-hidden":"index_overflow-hidden__Ks4r5","footer":"index_footer__wGHYS","footer-content-header":"index_footer-content-header__cRbdc","footer-content-headline-left":"index_footer-content-headline-left__m21qr","footer-content-headline-wrap":"index_footer-content-headline-wrap__4ch3X","footer-content-more":"index_footer-content-more__PX3ZN","container":"index_container__eQk0C","footer-content":"index_footer-content__nQkQp","footer-content-headline":"index_footer-content-headline__5wzkh","footer-bottom":"index_footer-bottom__A_Tt7","footer-line":"index_footer-line___7fXb","footer-text":"index_footer-text__x0WPy","privacy-policy":"index_privacy-policy__Zo6UU","version":"index_version__ieSfF","aboutUs":"index_aboutUs__xACSF","aboutUsText":"index_aboutUsText__8pWaf","guides":"index_guides__yuVRZ","guidesList":"index_guidesList__M8qb9","guidesItem":"index_guidesItem__EE2ST","contactUs":"index_contactUs__pI93w","contactChannelList":"index_contactChannelList__FUIIL","contactChannelItem":"index_contactChannelItem__c6Ty0","contactChannelItemName":"index_contactChannelItemName__R5wHt","qrCodeList":"index_qrCodeList__HprGX","qrCodeItem":"index_qrCodeItem__8osTx","moreGroup":"index_moreGroup__lrUWP","moreGroupBg":"index_moreGroupBg__5kXYo","moreGroupTitle":"index_moreGroupTitle__hJ50U","moreGroupDesc":"index_moreGroupDesc__6xqV2","moreGroupBtn":"index_moreGroupBtn__IGSKI","footer-product-icon":"index_footer-product-icon__XC1j1","footer-product-item":"index_footer-product-item__X8VvK","footer-product-content":"index_footer-product-content__cHOF_","footer-product-text":"index_footer-product-text__HyYwF","footer-product-name":"index_footer-product-name__0jahF"};

/***/ }),

/***/ 32735:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"updateLog":"index_updateLog__wNA_b","updateLog-icom":"index_updateLog-icom__3SZuG","updateLog-title":"index_updateLog-title__Jhq9i","updateLog-matter":"index_updateLog-matter__Q7eac","updateLog-matter-item":"index_updateLog-matter-item__4yNOV","updateLog-matter-icon":"index_updateLog-matter-icon__etA7F","updateLog-matter-text":"index_updateLog-matter-text__8HzY_","updateLog-footer":"index_updateLog-footer__YX1OD","updateLog-footer-discard":"index_updateLog-footer-discard__JZJxg","updateLog-footer-now":"index_updateLog-footer-now__804Yo","version":"index_version__5_wUK"};

/***/ })

}]);